import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Company } from '../../../models/company';
import { distinctUntilChanged, map } from 'rxjs';
import { findCompanyAct, findCompanyLogoAct, findUsersOfCompanyAct, updateCompanyAct, updateCompanyLogoAct } from '../../../store/companies/companies-actions';
import { AuthService } from '../../../services/auth.service';
import { Addresses } from '../../../models/addresses';
import { SignatureGroup } from '../../../models/signature-group';
import { findBenefitGroupsCatalogAct, findCostsPerEmployeeGroupsCatalogAct, findFormulaGroupsCatalogAct, findHolidayGroupsCatalogAct, findSignatureGroupsCatalogAct, findWithholdingGroupsCatalogAct } from '../../../store/catalog-offer/catalog-offer.actions';
import { HolidayGroup } from '../../../models/holiday-group';
import { BenefitGroup } from '../../../models/benefit-group';
import { User } from '../../../models/user';
import { WithholdingGroup } from '../../../models/withholding-group';
import { FormulaGroup } from '../../../models/formulas/formula-group';
import { CostsPerEmployeeGroup } from '../../../models/cost-per-employee-group';

@Component({
  selector: 'app-company-admin',
  standalone: false,
  templateUrl: './company-admin.component.html',
  styleUrl: './company-admin.component.css'
})
export class CompanyAdminComponent {

  loading: boolean = true;
  violations: any;
  companyForm!: NgForm;
  company: Company = new Company();
  authService = inject(AuthService);
  logoUrl?: string;

  signatureGroups: SignatureGroup[] = [];
  benefitGroups: BenefitGroup[] = [];
  holidayGroups: HolidayGroup[] = [];
  withholdingGroups: WithholdingGroup[] = [];
  formulaGroups: FormulaGroup[] = [];
  costsPerEmployeeGroups: CostsPerEmployeeGroup[] = [];
  //usersCompany: User[] = [];

  //columndefs : any[] = ['id','objectAttributeName','inOut','formula','objectAttributeObjectClassRouteClass','objectAttributeObjectClassObject','objectAttributeObjectTypeComments'];


ngOnInit(): void {
    
    this.route.paramMap.subscribe(params => {
      
      const id = this.authService.getCompanyId();
      this.companyStore.dispatch(findCompanyAct({ id }));
      this.companyStore.dispatch(findCompanyLogoAct({ id }));
      //this.companyStore.dispatch(findUsersOfCompanyAct({ id }));
    });

    this.catalogOfferStore.dispatch(findSignatureGroupsCatalogAct());
    this.catalogOfferStore.dispatch(findBenefitGroupsCatalogAct());
    this.catalogOfferStore.dispatch(findHolidayGroupsCatalogAct());
    this.catalogOfferStore.dispatch(findWithholdingGroupsCatalogAct());
    this.catalogOfferStore.dispatch(findFormulaGroupsCatalogAct());
    this.catalogOfferStore.dispatch(findCostsPerEmployeeGroupsCatalogAct());

  }

  constructor(
    private companyStore: Store<{ companyRdc: any }>,
    private route: ActivatedRoute,
    private catalogOfferStore: Store<{ catalogOfferRdc: any }>,
    private cd: ChangeDetectorRef
  ) {
    this.company = new Company(); // Inicialización segura por defecto

    this.companyStore.pipe(
        select('companyRdc'),
        map(state => ({ // filtra cuando cambian las propiedades que se usan en este componente
          company: state.company,
          violations: state.violations,
          loading: state.loading,
          logoUrl: state.logoUrl,
          //usersCompany: state.usersCompany
        })),
        // evita repeticiones
        distinctUntilChanged((prev, curr) =>
          JSON.stringify(prev) === JSON.stringify(curr)
        )
      ).subscribe(({ company, violations, loading, logoUrl }) => {
      this.violations = violations;
      this.company = JSON.parse(JSON.stringify(company)); // o mejor: _.cloneDeep(offer)
      if(this.company.addresses == null){
        this.company.addresses = new Addresses();
      }

      this.loading = loading;

      this.logoUrl = logoUrl; //URL.createObjectURL(logo);
      this.logoPreview = logoUrl;
      //this.usersCompany = usersCompany
      this.cd.markForCheck(); // fuerza la actualización de la vista
      //console.log("cargando " + this.loading);

      if(this.companyForm){
        for (const controlName in this.companyForm.controls) {
          if (this.companyForm.controls.hasOwnProperty(controlName)) {
            const control = this.companyForm.controls[controlName];
            if(this.violations[controlName]){
              control.setErrors({'incorrect': true});
              // para las validaciones en campos generados despues de renderizar 
            }
          }
        }
      }
    });

    this.catalogOfferStore.pipe(
      select('catalogOfferRdc'),
      map(state => ({ // filtra cuando cambian las propiedades que se usan en este componente
        signatureGroups: state.signatureGroups,
        benefitGroups: state.benefitGroups,
        holidayGroups: state.holidayGroups,
        withholdingGroups: state.withholdingGroups,
        formulaGroups: state.formulaGroups,
        costsPerEmployeeGroups: state.costsPerEmployeeGroups
      })),
      // evita repeticiones
      distinctUntilChanged((prev, curr) =>
        JSON.stringify(prev) === JSON.stringify(curr)
      )
    ).subscribe(({ signatureGroups, benefitGroups, holidayGroups, withholdingGroups, formulaGroups, costsPerEmployeeGroups}) => {
      this.signatureGroups = signatureGroups;
      this.benefitGroups = benefitGroups;
      this.holidayGroups = holidayGroups;
      this.withholdingGroups = withholdingGroups;
      this.formulaGroups = formulaGroups;
      this.costsPerEmployeeGroups = costsPerEmployeeGroups;
    });

  }


  onSubmit(companyForm: NgForm): void {
    this.loading = true;
    this.companyForm = companyForm;
    const companyCopy = JSON.parse(JSON.stringify(this.company));

    this.companyStore.dispatch(updateCompanyAct({ companyUpdated: companyCopy }));
    
  }
  logoPreview: string | ArrayBuffer | null = null;
  selectedFile: File | null = null;

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length > 0) {
      this.selectedFile = input.files[0];

      // Vista previa
      const reader = new FileReader();
      reader.onload = () => {
        this.logoPreview = reader.result;
      };
      reader.readAsDataURL(this.selectedFile);
    }
  }

  saveImage(): void {
    if (!this.selectedFile) return;
    this.companyStore.dispatch(updateCompanyLogoAct({ id: this.company.id, file: this.selectedFile }));

    console.log('Imagen guardada:', this.selectedFile);
  }
  
}


